<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useAppUpdate } from '@/shared/composables/use-app-update'

const { t } = useI18n()
const { updateAvailable, applyUpdate } = useAppUpdate()
</script>

<template>
  <Teleport to="body">
    <div
      v-if="updateAvailable"
      class="app-update-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="app-update-title"
    >
      <div class="app-update-modal__backdrop" />
      <div class="app-update-modal__panel">
        <p id="app-update-title" class="app-update-modal__title">
          {{ t('common.updateAvailableTitle') }}
        </p>
        <p class="app-update-modal__hint">{{ t('common.updateAvailableHint') }}</p>
        <button
          type="button"
          class="app-update-modal__btn"
          @click="applyUpdate"
        >
          {{ t('common.updateReloadNow') }}
        </button>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.app-update-modal {
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
}

.app-update-modal__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
}

.app-update-modal__panel {
  position: relative;
  width: min(26rem, 100%);
  border-radius: 1rem;
  padding: 1.35rem 1.25rem 1.2rem;
  background: #fff;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.28);
  text-align: center;
}

.app-update-modal__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.35;
  color: #0f172a;
}

.app-update-modal__hint {
  margin: 0.5rem 0 0;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.45;
  color: #475569;
}

.app-update-modal__btn {
  margin-top: 1.1rem;
  border: 0;
  border-radius: 999px;
  padding: 0.55rem 1.35rem;
  background: #1d4ed8;
  color: #fff;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.3;
  cursor: pointer;
}

.app-update-modal__btn:hover {
  background: #1e40af;
}
</style>
